import { useState } from "react";
import BMPolicyContents from "../BMPolicyContents/BMPolicyContents";
import ENPolicyContents from "../ENPolicyContents/ENPolicyContents";
import {
  DividerStyled,
  LabelStyled,
  PolicyContainer,
  PolicyLanguageContainer,
  Title,
} from "./styles";

function PrivacyPolicyWrapper(props) {
  const [toggle, setToggle] = useState(false);

  return (
    <PolicyContainer>
      {!toggle ? (
        <Title variant="h1">Privacy Policy</Title>
      ) : (
        <Title variant="h1">Polisi Privasi</Title>
      )}

      <br />
      <PolicyLanguageContainer>
        <LabelStyled $version_text onClick={() => setToggle(!toggle)}>
          {!toggle ? "VERSI BAHASA MALAYSIA" : "ENGLISH VERSION"}
        </LabelStyled>
      </PolicyLanguageContainer>

      <DividerStyled />
      {!toggle ? <ENPolicyContents /> : <BMPolicyContents />}
    </PolicyContainer>
  );
}

export default PrivacyPolicyWrapper;
